// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__dk112","insightsList":"newBusinessInsightsMenu_insightsList__B8TkM","active":"newBusinessInsightsMenu_active__1pk6O"};